module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-box"
  }, [_c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('programOverview')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('overViewInfo')))]), _vm._v(" "), _c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('duty')))]), _vm._v(" "), _c('p', {
    staticClass: "duty-info"
  }, [_vm._v(_vm._s(_vm.$t('dutyInfo')))]), _vm._v(" "), _vm._l((_vm.$t('dutyList')), function(duty, index) {
    return _c('p', {
      staticClass: "lists"
    }, [_c('span', {
      staticClass: "index"
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(_vm._s(duty) + "\n  ")])
  }), _vm._v(" "), _vm._l((_vm.$t('unsuitableList')), function(unsuitable) {
    return _c('p', {
      staticClass: "lists unsuitable"
    }, [_c('span', {
      staticClass: "index"
    }), _vm._v(_vm._s(unsuitable) + "\n  ")])
  }), _vm._v(" "), _c('p', {
    staticClass: "remind"
  }, [_vm._v(_vm._s(_vm.$t('remind')))]), _vm._v(" "), _c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('acceptableMethods')))]), _vm._v(" "), _c('p', {
    staticClass: "fallowingMethods"
  }, [_vm._v(_vm._s(_vm.$t('fallowingMethods')))]), _vm._v(" "), _vm._l((_vm.$t('methodsList')), function(methods, index) {
    return _c('p', {
      staticClass: "lists"
    }, [_c('span', {
      staticClass: "index"
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(_vm._s(methods) + "\n  ")])
  }), _vm._v(" "), _c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('modification')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('modificationInfo')))])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-543947ea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/affiliatePolicy/AffiliatePolicy.vue
// module id = 1324
// module chunks = 1